// extracted by mini-css-extract-plugin
export var container = "Z_h";
export var device = "Z_dv";
export var deviceContainer = "Z_dt";
export var icon = "Z_bw";
export var icons = "Z_bs";
export var image = "Z_k";
export var logo = "Z_bn";
export var model = "Z_dw";
export var section = "Z_j";